import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl';
import ConfigSettingsForm from '../../../components/SiteAdmin/ConfigSettingsForm ';
import Loader from '../../../components/Common/Loader/Loader';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';
import { decode, censorWord } from '../../../helpers/queryEncryption';
import { salesUser } from '../../../helpers/demoRestriction/demo';
import getSiteSettings from './getSiteSettings.graphql';

const ConfigSettings = ({ adminId, isDemoRestricted }) => {

  const { loading, data, refetch } = useQueryResponse({
    query: getSiteSettings,
    variables: { type: 'config_settings' },
    fetchPolicy: 'network-only',
  });

  const siteSettingsCollection = useMemo(() => {
    const results = data?.getSiteSettings?.results || [];
    return results.reduce((acc, { name, encryptValue }) => {
      if (name == 'paypalHost' || name == 'enableFirebase') {
        acc[name] = decode(encryptValue)
      } else {
        acc[name] = (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(encryptValue)) : decode(encryptValue)
      };
      acc['isRestrict'] = isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0;
      return acc;
    }, {});
  }, [data]);

  return (
    <Loader type="page" show={loading}>
      {!loading && (
        <ConfigSettingsForm
          refetch={refetch}
          getSiteSettings={data?.getSiteSettings}
          initialValues={siteSettingsCollection}
        />
      )}
    </Loader>
  );
};

export default injectIntl(ConfigSettings);